<div class="vacancy-card vacancy-card--bedrijven company-card">
  <div class="vacancy-card__title-row">
    <div class="company-card__logo" [style.background-color]="company.color || '#89CCDC'">
      {{ company.name?.charAt(0) }}
    </div>
    <div>
      <h3 class="vacancy-card__title">{{ company.name }}</h3>
      <p class="vacancy-card__subtitle">{{ company.location }}</p>
    </div>
  </div>

  <p class="company-card__description">{{ company.description }}</p>

  <div class="vacancy-card__actions">
    <button
      class="vacancy-btn-round vacancy-btn-heart"
      [class.vacancy-btn-heart--active]="isFollowed"
      (click)="onFollow($event)"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" [attr.fill]="isFollowed ? 'currentColor' : 'none'" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"/>
      </svg>
    </button>
    <a [routerLink]="['/profile-check/companies', company.id]" class="vacancy-btn-round vacancy-btn-arrow">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M5 12h14"/><path d="m12 5 7 7-7 7"/>
      </svg>
    </a>
  </div>
</div>
